enum QuizTypes {
  Scoring = 'scoring',
  Personality = 'personality',
  Prediction = 'prediction',
  Poll = 'poll',
  Survey = 'survey',
  RankingPoll = 'rankingPoll',
};

export default QuizTypes;
